export default __webpack_public_path__ + "static/media/Hand_right.1aab73ef.svg";